import type { SVGProps } from 'react';
const plus = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M12.745 3.66253C12.7016 3.28953 12.3846 3 12 3C11.5858 3 11.25 3.33579 11.25 3.75V11.25H3.75L3.66253 11.255C3.28953 11.2984 3 11.6154 3 12C3 12.4142 3.33579 12.75 3.75 12.75H11.25V20.25L11.255 20.3375C11.2984 20.7105 11.6154 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V12.75H20.25L20.3375 12.745C20.7105 12.7016 21 12.3846 21 12C21 11.5858 20.6642 11.25 20.25 11.25H12.75V3.75L12.745 3.66253Z"
      fill={props.color ?? 'black'}
      fillRule="evenodd"
    />
  </svg>
);
export default plus;
